<template>
    <div>
        <a href="" :class="(note_text) ? 'fa fa-sticky-note-o' : 'fa fa-plus'" @click.prevent="modalTrigger = true"></a>
        <modal v-if="modalTrigger" @close="modalTrigger = false" modalclass="note-modal">
            <h3 slot="header">Notes</h3>
            <div class="content" slot="body">
                <textarea v-model="note_text" rows="5"></textarea>
            </div>
            <div class="form-group-submit clearfix" slot="footer">
                <button class="btn btn-cancel btn-transparent pull-left" @click="modalTrigger = false">Close</button>
                <button class="pull-right" @click.prevent="applyChange">Save</button>
            </div>
        </modal>
    </div>
</template>

<script>
    import axios from 'axios';
    import modal from './Modal.vue';
    export default {
        props: ['note', 'vfoid'],
        components: {modal},
        data() {
            return {
                modalTrigger: false,
                note_text: this.note,
            }
        },
        methods: {
            applyChange: function() {
                let that = this;
                let actionUrl = '/video/update/' + that.vfoid;
                axios(
                    {
                        method: 'POST',
                        url: actionUrl,
                        data: {
                            notes: that.note_text,
                            token: false
                        }
                    }).then(function(response) {
                    that.modalTrigger = false;
                }).catch(function (error) {
                    // handle error
                    console.log('This is the error returned', error);
                });
            }
        }
    }
</script>
